(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class CustomerReviewsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.customer-reviews__slider');
      this.prevButton = this.querySelector('.customer-reviews__arrow--prev');
      this.nextButton = this.querySelector('.customer-reviews__arrow--next');
      this.dotsContainer = this.querySelector('.customer-reviews__dots');
      this.items = this.querySelectorAll('.customer-reviews__item');
      this.currentIndex = 0;
      this.autoRotate = this.dataset.autoRotate === 'true';
      this.changeSpeed = parseInt(this.dataset.changeSlidesSpeed) || 5;
      this.autoRotateInterval = null;
      
      if (this.slider && this.dataset.layout === 'slider') {
        this.init();
      }
    }

    init() {
      this.createDots();
      this.setupControls();
      this.updateButtons();
      
      if (this.autoRotate) {
        this.startAutoRotate();
        this.slider.addEventListener('mouseenter', () => this.stopAutoRotate());
        this.slider.addEventListener('mouseleave', () => this.startAutoRotate());
      }

      // Update on scroll
      this.slider.addEventListener('scroll', () => {
        this.updateCurrentIndex();
        this.updateButtons();
      });
    }

    createDots() {
      if (!this.dotsContainer || !this.items.length) return;
      
      // Calcola il numero di pagine in base alle recensioni visibili
      const totalPages = this.items.length;
      
      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.className = 'customer-reviews__dot';
        dot.setAttribute('aria-label', `Vai alla recensione ${i + 1}`);
        if (i === 0) dot.classList.add('active');
        
        dot.addEventListener('click', () => {
          this.goToSlide(i);
        });
        
        this.dotsContainer.appendChild(dot);
      }
    }

    setupControls() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prev());
      }
      
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.next());
      }
    }

    prev() {
      if (this.currentIndex > 0) {
        this.goToSlide(this.currentIndex - 1);
      } else {
        // Loop to last
        this.goToSlide(this.items.length - 1);
      }
      this.resetAutoRotate();
    }

    next() {
      if (this.currentIndex < this.items.length - 1) {
        this.goToSlide(this.currentIndex + 1);
      } else {
        // Loop to first
        this.goToSlide(0);
      }
      this.resetAutoRotate();
    }

    goToSlide(index) {
      if (!this.items[index]) return;
      
      const item = this.items[index];
      item.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
      
      this.currentIndex = index;
      this.updateDots(index);
      this.updateButtons();
    }

    updateCurrentIndex() {
      if (!this.slider || !this.items.length) return;
      
      const scrollLeft = this.slider.scrollLeft;
      const itemWidth = this.items[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.slider).gap) || 0;
      
      const newIndex = Math.round(scrollLeft / (itemWidth + gap));
      
      if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.items.length) {
        this.currentIndex = newIndex;
        this.updateDots(newIndex);
      }
    }

    updateDots(index) {
      const dots = this.dotsContainer?.querySelectorAll('.customer-reviews__dot');
      dots?.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    }

    updateButtons() {
      if (!this.prevButton || !this.nextButton) return;
      
      // Never disable buttons - they loop
      this.prevButton.disabled = false;
      this.nextButton.disabled = false;
    }

    startAutoRotate() {
      if (!this.autoRotate) return;
      
      this.autoRotateInterval = setInterval(() => {
        this.next();
      }, this.changeSpeed * 1000);
    }

    stopAutoRotate() {
      if (this.autoRotateInterval) {
        clearInterval(this.autoRotateInterval);
        this.autoRotateInterval = null;
      }
    }

    resetAutoRotate() {
      this.stopAutoRotate();
      if (this.autoRotate) {
        this.startAutoRotate();
      }
    }

    disconnectedCallback() {
      this.stopAutoRotate();
    }
  }

  if (!customElements.get('customer-reviews-slider')) {
    customElements.define('customer-reviews-slider', CustomerReviewsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (window.location.hash) {
    const scrollToCard = () => {
      const card = document.getElementById(window.location.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant', block: 'start' });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollToCard, { once: true });
    } else {
      scrollToCard();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
